import type { TwinAssetResponse } from '@repo/front-end-services';
import { normaliseAssetUid } from '@repo/frontend-types';

/**
 * The Asset Register's catalogue reference per register row, keyed the way a plan item's
 * `assetUid` is — `twin-launch-history-bi-push` R2.
 *
 * Go Live hands this to `convertPlanToTwin`, which writes each linked item's reference into its
 * dGraph `definitions.equipment_id`: the field the BI manufacturer-hierarchy import reads. Rows with
 * no reference (unmatched, or `uncatalogued`) are left out, so their items get no `equipment_id`.
 *
 * Keyed with `normaliseAssetUid` — the same normalisation the entity factory applies to
 * `item.assetUid` — so the two sides cannot disagree about which row an item names.
 */
export const referenceIdsByAssetUid = (
  rows: readonly Pick<TwinAssetResponse, 'id' | 'reference_id'>[],
): ReadonlyMap<string, string> => {
  const byUid = new Map<string, string>();
  for (const row of rows) {
    const uid = normaliseAssetUid(row.id);
    const reference = row.reference_id?.trim();
    if (uid && reference) byUid.set(uid, reference);
  }
  return byUid;
};
